import { render, staticRenderFns } from "./learn.vue?vue&type=template&id=036846ee&scoped=true&"
import script from "./learn.vue?vue&type=script&lang=js&"
export * from "./learn.vue?vue&type=script&lang=js&"
import style0 from "./learn.vue?vue&type=style&index=0&id=036846ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036846ee",
  null
  
)

export default component.exports